import { render } from "./SidebarLink.vue?vue&type=template&id=23c3ad88&scoped=true"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"

import "./SidebarLink.vue?vue&type=style&index=0&id=23c3ad88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3ad88"]])

export default __exports__